import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import PageTitle from "Components/PageTitle/PageTitle";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { settingSelectedProject } from "Constants/TableColumns";
import { read } from "Helpers/LocalStorage";
import { getSettingProjects_selectedProjectUnits } from "Stores/actions/properties/ShopAction";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import { useTranslation } from "react-i18next";

export default function SelectedProjectUnits({ nameSearch }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { list, pagination, selectedProject } = useSelector((state) => ({
    list: state.shop.selectedProjectUnits_List,
    pagination: state.shop.selectedProjectUnits_Pagination,
    selectedProject: state.shop.selectedProject,
  }));
  const [sizePerPage, setSizePerPage] = useState(pagination.Limit);
  const [currentPage, setCurrentPage] = useState(pagination.Page);
  const [total, setTotal] = useState(pagination.Total);
  const [tblData, setTblData] = useState(list);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setTblData(list);
  }, [list]);

  useEffect(() => {
    setCurrentPage(pagination.Page);
    setSizePerPage(pagination.Limit);
    setTotal(pagination.Total);
  }, [pagination]);

  useEffect(() => {
    if (selectedProject) {
      (async () => {
        await getList();
      })();
    }
  }, [selectedProject]);

  const onTableChange = async (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      try {
        await getList(page, sizePerPage);
      } catch (err) {
        console.error("[catch error]", err);
      }
    }
  };

  const getList = async (
    Page = currentPage,
    Limit = sizePerPage,
    data = "NODATA"
  ) => {
    setLoading(true);
    try {
      let dataSearch = null;
      if (data !== "NODATA") {
        if (data !== "") dataSearch = { Name: data };
      } else if (nameSearch !== "")
        dataSearch = {
          Name: nameSearch,
        };
      await dispatch(
        getSettingProjects_selectedProjectUnits({
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdProject: selectedProject.IdProject,
          IdType: selectedProject.IdType,
          Limit,
          Page,
          ...dataSearch,
        })
      );
    } catch (err) {
      console.error("[onGetGroupTemplates]", err);
    }
    setTimeout(() => {
      setLoading(false);
    }, 200);
  };

  return (
    <>
      {selectedProject && (
        <>
          <div className={`page-top-title-button mb-3 mt-5`}>
            <PageTitle
              title={
                <span>
                  {`${t("unitList2")} - ${selectedProject.Name} - ${
                    selectedProject.Project
                  }`}
                </span>
              }
            />
          </div>
          <BackDropLoading loading={loading} />
          <MuiPaper>
            <Fragment>
              <RemoteTable
                data={tblData}
                keyField="Id"
                columns={settingSelectedProject}
                loading={loading}
                page={currentPage}
                sizePerPage={sizePerPage}
                totalSize={total}
                onTableChange={onTableChange}
              />
            </Fragment>
          </MuiPaper>
        </>
      )}
    </>
  );
}
